'use client';

import { useMemo } from 'react';

import { core } from './localization/core';
import { useIntercom } from './useIntercom';
import { useRedirectionPayphone } from './UseRedirectionPayphone';
import { useToastNotifications } from './useToastNotifications';
import { useUnlimitTransaction } from './useUnlimitTransaction';

export const useHomeLogicClient = () => {
  // messages for toast notifications
  const messagesLimits = useMemo(() => {
    return {
      1: `${core.limit} ${core.limitDaily}`,
      2: `${core.limit} ${core.limitWeekly}`,
      3: `${core.limit} ${core.limitMonthly}`,
    };
  }, []);

  const textVerified = useMemo(() => {
    return {
      1: core.verified,
      2: core.errorVerified,
    };
  }, []);

  // initialize all hooks
  useIntercom();
  useToastNotifications(messagesLimits, textVerified);
  useUnlimitTransaction();
  useRedirectionPayphone();
};
